import { render, staticRenderFns } from "./form-new-contact.vue?vue&type=template&id=a30b6ff8"
import script from "./form-new-contact.vue?vue&type=script&lang=js"
export * from "./form-new-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a30b6ff8')) {
      api.createRecord('a30b6ff8', component.options)
    } else {
      api.reload('a30b6ff8', component.options)
    }
    module.hot.accept("./form-new-contact.vue?vue&type=template&id=a30b6ff8", function () {
      api.rerender('a30b6ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/quick-message/form-new-contact.vue"
export default component.exports